import { ErrorPage404Query } from '@/graphql';
import ErrorPage404QueryDocument from '@/graphql/queries/ErrorPage404.gql';
import ErrorPage404OutLayout from '@/layouts/EmailOptInOutLayout';
import { getStaticPageProps } from '@/lib/next';
import { getSingle } from '@/lib/typescript-helpers';
import MasterTemplate from '@/templates/MasterTemplate';

const ErrorPage404: PageTemplate<ErrorPage404Query> = ({ entry }) => {
  const { image: imageArray } = entry!;

  const image = getSingle(imageArray);

  return (
    <ErrorPage404OutLayout
      analyticsCategory="404 Page"
      heading={entry?.heading1 ?? ''}
      text={entry?.text ?? ''}
      image={
        !!image
          ? {
              url: image?.url!,
              width: image?.width!,
              height: image?.height!,
              altText: image?.altText!,
            }
          : undefined
      }
    />
  );
};

ErrorPage404.template = MasterTemplate;

export default ErrorPage404;

export const getStaticProps = getStaticPageProps('404', async ({ client }) => {
  const props = await client.request<ErrorPage404Query>(ErrorPage404QueryDocument);

  return { props };
});
